/**
 * Request object that the Report methods are expecting.
 */
const ReportRequest = function ReportRequest() {
  return {
    reportType: 'CarrierActivity', // i.e. 'carrier', 'state', 'agent'
    dateTo: '',
    dateFrom: '',
    dateRange: '', // TODO: Use config values
    dimensions: [],
    filters: {},
    columns: [], // aka "select [column names]"
    sortBy: '', // aka "order by [column names]"
    sort: '', // aka "asc/desc"
    rowStart: 0, // aka "limit [start]"
    rowCount: 10, // aka "limit [end]"
    format: '', // TODO: Use config values
  };
};
/**
 * export service to used by different components
 */
export default ReportRequest;



// WEBPACK FOOTER //
// ./src/services/ReportRequest.js